/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LicenseStatus } from './LicenseStatus';
import {
    LicenseStatusFromJSON,
    LicenseStatusFromJSONTyped,
    LicenseStatusToJSON,
    LicenseStatusToJSONTyped,
} from './LicenseStatus';
import type { RoleRead } from './RoleRead';
import {
    RoleReadFromJSON,
    RoleReadFromJSONTyped,
    RoleReadToJSON,
    RoleReadToJSONTyped,
} from './RoleRead';

/**
 * 
 * @export
 * @interface UserOrganization
 */
export interface UserOrganization {
    /**
     * 
     * @type {string}
     * @memberof UserOrganization
     */
    organization_id: string;
    /**
     * 
     * @type {string}
     * @memberof UserOrganization
     */
    organization_name: string;
    /**
     * 
     * @type {number}
     * @memberof UserOrganization
     */
    role_id: number;
    /**
     * 
     * @type {string}
     * @memberof UserOrganization
     */
    role_name: string;
    /**
     * 
     * @type {Array<RoleRead>}
     * @memberof UserOrganization
     */
    roles: Array<RoleRead>;
    /**
     * 
     * @type {boolean}
     * @memberof UserOrganization
     */
    is_owner: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserOrganization
     */
    is_active: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserOrganization
     */
    license_type: string | null;
    /**
     * 
     * @type {number}
     * @memberof UserOrganization
     */
    max_users: number;
    /**
     * 
     * @type {number}
     * @memberof UserOrganization
     */
    total_users: number;
    /**
     * 
     * @type {LicenseStatus}
     * @memberof UserOrganization
     */
    license_status: LicenseStatus;
    /**
     * 
     * @type {Date}
     * @memberof UserOrganization
     */
    license_valid_until?: Date | null;
}



/**
 * Check if a given object implements the UserOrganization interface.
 */
export function instanceOfUserOrganization(value: object): value is UserOrganization {
    if (!('organization_id' in value) || value['organization_id'] === undefined) return false;
    if (!('organization_name' in value) || value['organization_name'] === undefined) return false;
    if (!('role_id' in value) || value['role_id'] === undefined) return false;
    if (!('role_name' in value) || value['role_name'] === undefined) return false;
    if (!('roles' in value) || value['roles'] === undefined) return false;
    if (!('is_owner' in value) || value['is_owner'] === undefined) return false;
    if (!('is_active' in value) || value['is_active'] === undefined) return false;
    if (!('license_type' in value) || value['license_type'] === undefined) return false;
    if (!('max_users' in value) || value['max_users'] === undefined) return false;
    if (!('total_users' in value) || value['total_users'] === undefined) return false;
    if (!('license_status' in value) || value['license_status'] === undefined) return false;
    return true;
}

export function UserOrganizationFromJSON(json: any): UserOrganization {
    return UserOrganizationFromJSONTyped(json, false);
}

export function UserOrganizationFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserOrganization {
    if (json == null) {
        return json;
    }
    return {
        
        'organization_id': json['organization_id'],
        'organization_name': json['organization_name'],
        'role_id': json['role_id'],
        'role_name': json['role_name'],
        'roles': ((json['roles'] as Array<any>).map(RoleReadFromJSON)),
        'is_owner': json['is_owner'],
        'is_active': json['is_active'],
        'license_type': json['license_type'],
        'max_users': json['max_users'],
        'total_users': json['total_users'],
        'license_status': LicenseStatusFromJSON(json['license_status']),
        'license_valid_until': json['license_valid_until'] == null ? undefined : (new Date(json['license_valid_until'])),
    };
}

export function UserOrganizationToJSON(json: any): UserOrganization {
    return UserOrganizationToJSONTyped(json, false);
}

export function UserOrganizationToJSONTyped(value?: UserOrganization | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'organization_id': value['organization_id'],
        'organization_name': value['organization_name'],
        'role_id': value['role_id'],
        'role_name': value['role_name'],
        'roles': ((value['roles'] as Array<any>).map(RoleReadToJSON)),
        'is_owner': value['is_owner'],
        'is_active': value['is_active'],
        'license_type': value['license_type'],
        'max_users': value['max_users'],
        'total_users': value['total_users'],
        'license_status': LicenseStatusToJSON(value['license_status']),
        'license_valid_until': value['license_valid_until'] == null ? undefined : ((value['license_valid_until'] as any).toISOString()),
    };
}

